import EditPersonForm from './EditPersonForm';

export default EditPersonForm;
